import { Mobile, Navigation } from './core'
import Header from './modules/header'
import Projects from './plugins/projects'
import GoogleMaps from './plugins/google-map'
import Filterizr from 'filterizr';
import './plugins/fixed-content'

/* On page load */
$(window).on('page_load', function(event, loadedContent) {
  /* */
  if (loadedContent) {
    $.mlmi.mobile = new Mobile()
    $.mlmi.scroller = $(window).ScrollEvents()
    $('head, body').attr('class', $('.app').data('view'))
  }

  /* Remember color */
  $.mlmi.colors[location.href] = $('.app').data('color')

  /* Prevent empty anchor clicks */
  $('a[href="#"]').on("click", function() {
    return false
  })

  /* Contact map */
  $('.contact-map').each(function() {
    $(this).ContactMap()
  })

  /* Contact footer */
  if ($('.page-contact').length) {
    $('.app').append($('.footer'))
  }

  /* Init Isotope style filtering */
  Projects.initFiltering()

  $('.project-categories__link').each(function() {
    $(this).selectProjectCategory()
  })

  $.mlmi.mobile.addCallbacks(function() {
    /* Mobile */

    /* Shrink header when scrolling down */
    Header.minimize()

    /* Toggle Project Categories on Mobile */
    $('.projects-sidebar').each(function() {
      $(this).ToggleProjectCategories()
    })

    /* Do not use fixed content */
    $('.projects-sidebar, .single-project__infos').each(function() {
      if ($(this).data('fixedContent')) {
        $(this).data('fixedContent').destroy()
      }
    })

  }, function() {
    /* Desktop */

    $('.projects-sidebar, .single-project__infos').each(function() {
      let fixedContent = $(this).FixedContent({
        limitFromTop: $('.header').height(),
      })
    })

    /* Wrap location and year together for grid display */
    $('.projects').each(function() {
      $(this).changeProjectsMarkup()
    })
  })

  /* Header */
  $.mlmi.header = Header.init()
})

/* On page exit */
$(window).on('page_exit', function() {
  /* Unload images */
  $('.app').find('img').attr('src', '').remove()
  $('body, html').scrollTop(0);

  /* Unload dynamic styles */
  $('.dynamic-styles, .footer').remove()

  /* Kill... */
  $.mlmi.mobile.kill()
  $.mlmi.scroller.kill()

  /* Hide menu immediately */
  $('body').removeClass('--menu-open')
  $('.menu-panel').css('display', 'none')

  /* Close mobile menu */
  if ($.mlmi.mobile.isMobile) {
    $('.burger--close').click()
  }
})

let navigation = undefined

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    scroller: $(window).ScrollEvents(),
    color: '#ffffff',
    colors: {},
  }

  navigation = new Navigation({
    minTransitionTime: .2,
    selectors: {
      pageContent: '.app, .footer, .dynamic-styles',
    },
    on: {
      beforeRegisterLinks: function() {
        $('.projects-sidebar a').data('preventTransition', 1)
      },
      linkClicked: function(link) {
        if (link.data('color')) {
          $.mlmi.color = link.data('color')
          $.mlmi.colors[encodeURI(link.attr('href'))] = link.data('color')
          $('.page-transition').css('background-color', $.mlmi.color)
          $('.page-transition svg path#transition-color').attr('fill', $.mlmi.color)
        } else {
          $('.page-transition').css('background-color', '')
          $('.page-transition svg path#transition-color').attr('fill', '')
        }
      },
      popState: function(url, popState) {
        if (popState.color) {
          $.mlmi.color = popState.color
          $('.page-transition').css('background-color', $.mlmi.color)
          $('.page-transition svg path#transition-color').attr('fill', $.mlmi.color)
        }
        return true
      },
    },
    filter: {
      popState: function(popState) {
        if ($('.app').data('color')) {
          popState.color = $('.app').data('color')
        }
        return popState
      }
    },
  })
})
